import { render, staticRenderFns } from "./button-group.vue?vue&type=template&id=122c06b2&scoped=true&"
import script from "./button-group.ts?vue&type=script&lang=ts&"
export * from "./button-group.ts?vue&type=script&lang=ts&"
import style0 from "./button-group.scss?vue&type=style&index=0&id=122c06b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122c06b2",
  null
  
)

export default component.exports